/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { RelatedDeviceDto } from "./RelatedDeviceDto";
import {
    RelatedDeviceDtoFromJSON,
    RelatedDeviceDtoFromJSONTyped,
    RelatedDeviceDtoToJSON,
} from "./RelatedDeviceDto";
import type { WaveMetadataDto } from "./WaveMetadataDto";
import {
    WaveMetadataDtoFromJSON,
    WaveMetadataDtoFromJSONTyped,
    WaveMetadataDtoToJSON,
} from "./WaveMetadataDto";
import type { DeviceConfigurationItemDto } from "./DeviceConfigurationItemDto";
import {
    DeviceConfigurationItemDtoFromJSON,
    DeviceConfigurationItemDtoFromJSONTyped,
    DeviceConfigurationItemDtoToJSON,
} from "./DeviceConfigurationItemDto";
import type { DeviceCatalogueDto } from "./DeviceCatalogueDto";
import {
    DeviceCatalogueDtoFromJSON,
    DeviceCatalogueDtoFromJSONTyped,
    DeviceCatalogueDtoToJSON,
} from "./DeviceCatalogueDto";
import type { AddressDto } from "./AddressDto";
import {
    AddressDtoFromJSON,
    AddressDtoFromJSONTyped,
    AddressDtoToJSON,
} from "./AddressDto";
import type { DeviceUptimeResponse } from "./DeviceUptimeResponse";
import {
    DeviceUptimeResponseFromJSON,
    DeviceUptimeResponseFromJSONTyped,
    DeviceUptimeResponseToJSON,
} from "./DeviceUptimeResponse";
import type { ChargePointMetadataDto } from "./ChargePointMetadataDto";
import {
    ChargePointMetadataDtoFromJSON,
    ChargePointMetadataDtoFromJSONTyped,
    ChargePointMetadataDtoToJSON,
} from "./ChargePointMetadataDto";
import type { ConnectorDto } from "./ConnectorDto";
import {
    ConnectorDtoFromJSON,
    ConnectorDtoFromJSONTyped,
    ConnectorDtoToJSON,
} from "./ConnectorDto";
import type { CoreMetadataDto } from "./CoreMetadataDto";
import {
    CoreMetadataDtoFromJSON,
    CoreMetadataDtoFromJSONTyped,
    CoreMetadataDtoToJSON,
} from "./CoreMetadataDto";
import type { LinkMetadataDto } from "./LinkMetadataDto";
import {
    LinkMetadataDtoFromJSON,
    LinkMetadataDtoFromJSONTyped,
    LinkMetadataDtoToJSON,
} from "./LinkMetadataDto";
import type { PowerMeterMetadataDto } from "./PowerMeterMetadataDto";
import {
    PowerMeterMetadataDtoFromJSON,
    PowerMeterMetadataDtoFromJSONTyped,
    PowerMeterMetadataDtoToJSON,
} from "./PowerMeterMetadataDto";
import type { DeviceConfigurationExtendedItemDto } from "./DeviceConfigurationExtendedItemDto";
import {
    DeviceConfigurationExtendedItemDtoFromJSON,
    DeviceConfigurationExtendedItemDtoFromJSONTyped,
    DeviceConfigurationExtendedItemDtoToJSON,
} from "./DeviceConfigurationExtendedItemDto";
import type { PayMateMetadataDto } from "./PayMateMetadataDto";
import {
    PayMateMetadataDtoFromJSON,
    PayMateMetadataDtoFromJSONTyped,
    PayMateMetadataDtoToJSON,
} from "./PayMateMetadataDto";

/**
 *
 * @export
 * @interface DeviceDto
 */
export interface DeviceDto {
    /**
     *
     * @type {number}
     * @memberof DeviceDto
     */
    installationId?: number;
    /**
     * 0 for active devices. When a device is archived, this is set to the next-highest available number for the same DeviceIdentity. Eg CM001 archiveId 0 (active), CM001 archiveId 1 (older), CM001 archiveId 2 (oldest).
     * @type {number}
     * @memberof DeviceDto
     */
    deviceArchiveId?: number;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    deviceIdentity: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    organisationId?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    deviceType?: DeviceDtoDeviceTypeEnum;
    /**
     * Date that the device is marked as operational. Device is not accounted for in uptime calculation before this date.
     * @type {Date}
     * @memberof DeviceDto
     */
    operationalAt?: Date;
    /**
     * Date the device was first created on the Illuminate platform. This can occur before first boot.
     * @type {Date}
     * @memberof DeviceDto
     */
    createdAt?: Date;
    /**
     * Date device details were last updated on the Illuminate platform, eg due to connector or status change
     * @type {Date}
     * @memberof DeviceDto
     */
    updatedAt?: Date;
    /**
     * Date of last online status update.
     * @type {Date}
     * @memberof DeviceDto
     */
    onlineStatusUpdatedAt?: Date;
    /**
     * Date of last status update.
     * @type {Date}
     * @memberof DeviceDto
     */
    statusUpdatedAt?: Date;
    /**
     * Date when the device was decommissioned. Null if the device is not decommissioned.
     * @type {Date}
     * @memberof DeviceDto
     */
    decommissionedAt?: Date;
    /**
     * Date and time when temporary reprovisioning access expires. Null if device is not in reprovisioning state.
     * @type {Date}
     * @memberof DeviceDto
     */
    reprovisioningExpiresAt?: Date;
    /**
     * Status of registration on the Illuminate platform.
     * @type {string}
     * @memberof DeviceDto
     */
    deviceRegistrationStatus?: DeviceDtoDeviceRegistrationStatusEnum;
    /**
     * Boot notification state
     * @type {string}
     * @memberof DeviceDto
     */
    serviceDeviceState?: DeviceDtoServiceDeviceStateEnum;
    /**
     * True if the device is online and connected to Illuminate.
     * @type {boolean}
     * @memberof DeviceDto
     */
    online?: boolean;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    serialNumber?: string;
    /**
     * Device reported manufacturer, eg 'Jetcharge', 'Tritium'
     * @type {string}
     * @memberof DeviceDto
     */
    vendor?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    fwVersion?: string;
    /**
     * Device reported model, eg 'ChargeMate3P22'. See DeviceCatalogue for a simplified model name.
     * @type {string}
     * @memberof DeviceDto
     */
    model?: string;
    /**
     * Raw status as reported from the device, eg Available/CONNECTED/DISCONNECTED/Unknown
     * @type {string}
     * @memberof DeviceDto
     */
    status?: string;
    /**
     * Consolidated device state
     * @type {string}
     * @memberof DeviceDto
     */
    simpleDeviceState?: DeviceDtoSimpleDeviceStateEnum;
    /**
     * Parent, if connected to a Wave or Core
     * @type {number}
     * @memberof DeviceDto
     */
    parentInstallationId?: number;
    /**
     * PayMate, if linked to a PayMate
     * @type {number}
     * @memberof DeviceDto
     */
    payMateDeviceInstallationId?: number;
    /**
     * If present, this is a *virtual charger*, passed through to this third party central system. The real device is at ParentInstallationId.
     * @type {number}
     * @memberof DeviceDto
     */
    passthroughConfigId?: number;
    /**
     * If present, this is a *readonly passthrough*, read from this third party central system. The real device is connected directly to the third party.
     * @type {number}
     * @memberof DeviceDto
     */
    readonlyPassthroughConfigId?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceDto
     */
    latitude?: number;
    /**
     *
     * @type {number}
     * @memberof DeviceDto
     */
    longitude?: number;
    /**
     * Old single field address. Migrate to separate Address fields.
     * @type {string}
     * @memberof DeviceDto
     */
    address?: string;
    /**
     *
     * @type {number}
     * @memberof DeviceDto
     */
    deviceOwnerId?: number;
    /**
     * User-facing non-unique name
     * @type {string}
     * @memberof DeviceDto
     */
    friendlyName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    timeZone?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    siteName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    organisationName?: string;
    /**
     *
     * @type {string}
     * @memberof DeviceDto
     */
    internalNotes?: string;
    /**
     *
     * @type {DeviceUptimeResponse}
     * @memberof DeviceDto
     */
    deviceUptime?: DeviceUptimeResponse;
    /**
     * If this is a Wave or Core, the child chargers and power meters
     * @type {Array<RelatedDeviceDto>}
     * @memberof DeviceDto
     */
    childDevices?: Array<RelatedDeviceDto>;
    /**
     * If this is a PayMate, this is its chargers
     * @type {Array<RelatedDeviceDto>}
     * @memberof DeviceDto
     */
    payMateChargerDevices?: Array<RelatedDeviceDto>;
    /**
     * Only returned for OrgGroupJETCharge. List of Organisations and OrganisationGroups that can manage this device
     * @type {Array<string>}
     * @memberof DeviceDto
     */
    accessTags?: Array<string>;
    /**
     *
     * @type {Array<string>}
     * @memberof DeviceDto
     */
    deviceGroupTags?: Array<string>;
    /**
     *
     * @type {Array<DeviceConfigurationItemDto>}
     * @memberof DeviceDto
     */
    configurationItems?: Array<DeviceConfigurationItemDto>;
    /**
     *
     * @type {Array<DeviceConfigurationExtendedItemDto>}
     * @memberof DeviceDto
     */
    configurationExtendedItems?: Array<DeviceConfigurationExtendedItemDto>;
    /**
     *
     * @type {Array<ConnectorDto>}
     * @memberof DeviceDto
     */
    connectors?: Array<ConnectorDto>;
    /**
     *
     * @type {ChargePointMetadataDto}
     * @memberof DeviceDto
     */
    chargePointMetadata?: ChargePointMetadataDto;
    /**
     *
     * @type {LinkMetadataDto}
     * @memberof DeviceDto
     */
    linkMetadata?: LinkMetadataDto;
    /**
     *
     * @type {PowerMeterMetadataDto}
     * @memberof DeviceDto
     */
    powerMeterMetadata?: PowerMeterMetadataDto;
    /**
     *
     * @type {WaveMetadataDto}
     * @memberof DeviceDto
     */
    waveMetadata?: WaveMetadataDto;
    /**
     *
     * @type {CoreMetadataDto}
     * @memberof DeviceDto
     */
    coreMetadata?: CoreMetadataDto;
    /**
     *
     * @type {PayMateMetadataDto}
     * @memberof DeviceDto
     */
    payMateMetadata?: PayMateMetadataDto;
    /**
     *
     * @type {AddressDto}
     * @memberof DeviceDto
     */
    deviceAddress?: AddressDto;
    /**
     * Active protocol
     * @type {string}
     * @memberof DeviceDto
     */
    protocol?: DeviceDtoProtocolEnum;
    /**
     * All reported protocols this device supports
     * @type {Array<string>}
     * @memberof DeviceDto
     */
    reportedProtocols?: Array<string>;
    /**
     * True if the device is decommissioned
     * @type {boolean}
     * @memberof DeviceDto
     */
    isDecommissioned?: boolean;
    /**
     *
     * @type {DeviceCatalogueDto}
     * @memberof DeviceDto
     */
    deviceCatalogue?: DeviceCatalogueDto;
}

/**
 * @export
 */
export const DeviceDtoDeviceTypeEnum = {
    ChargePoint: "ChargePoint",
    Illuminate: "Illuminate",
    ThirdPartyPassthrough: "ThirdPartyPassthrough",
    PayMate: "PayMate",
    Wave: "Wave",
    PowerMeter: "PowerMeter",
    Core: "Core",
    Barrier: "Barrier",
} as const;
export type DeviceDtoDeviceTypeEnum =
    (typeof DeviceDtoDeviceTypeEnum)[keyof typeof DeviceDtoDeviceTypeEnum];

/**
 * @export
 */
export const DeviceDtoDeviceRegistrationStatusEnum = {
    Unverified: "Unverified",
    Inactive: "Inactive",
    Active: "Active",
} as const;
export type DeviceDtoDeviceRegistrationStatusEnum =
    (typeof DeviceDtoDeviceRegistrationStatusEnum)[keyof typeof DeviceDtoDeviceRegistrationStatusEnum];

/**
 * @export
 */
export const DeviceDtoServiceDeviceStateEnum = {
    NewDevice: "NewDevice",
    SetNewAuthKey: "SetNewAuthKey",
    ResetDevice: "ResetDevice",
    GetConfiguration: "GetConfiguration",
    WaitForActivate: "WaitForActivate",
    NewFirmware: "NewFirmware",
    Registered: "Registered",
} as const;
export type DeviceDtoServiceDeviceStateEnum =
    (typeof DeviceDtoServiceDeviceStateEnum)[keyof typeof DeviceDtoServiceDeviceStateEnum];

/**
 * @export
 */
export const DeviceDtoSimpleDeviceStateEnum = {
    Unknown: "Unknown",
    Available: "Available",
    InUse: "InUse",
    Faulted: "Faulted",
    Raised: "Raised",
    Lowered: "Lowered",
    NoCurtailment: "NoCurtailment",
    LightCurtailment: "LightCurtailment",
    HeavyCurtailment: "HeavyCurtailment",
} as const;
export type DeviceDtoSimpleDeviceStateEnum =
    (typeof DeviceDtoSimpleDeviceStateEnum)[keyof typeof DeviceDtoSimpleDeviceStateEnum];

/**
 * @export
 */
export const DeviceDtoProtocolEnum = {
    Unknown: "Unknown",
    Ocpp16: "ocpp1.6",
    Jcwp18: "jcwp1.8",
    Jclp11: "jclp1.1",
    Jccp: "jccp",
    JcppPb: "jcpp-pb",
    Ocpp201: "ocpp2.0.1",
} as const;
export type DeviceDtoProtocolEnum =
    (typeof DeviceDtoProtocolEnum)[keyof typeof DeviceDtoProtocolEnum];

/**
 * Check if a given object implements the DeviceDto interface.
 */
export function instanceOfDeviceDto(value: object): value is DeviceDto {
    if (!("deviceIdentity" in value) || value["deviceIdentity"] === undefined)
        return false;
    return true;
}

export function DeviceDtoFromJSON(json: any): DeviceDto {
    return DeviceDtoFromJSONTyped(json, false);
}

export function DeviceDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): DeviceDto {
    if (json == null) {
        return json;
    }
    return {
        installationId:
            json["installationId"] == null ? undefined : json["installationId"],
        deviceArchiveId:
            json["deviceArchiveId"] == null
                ? undefined
                : json["deviceArchiveId"],
        deviceIdentity: json["deviceIdentity"],
        organisationId:
            json["organisationId"] == null ? undefined : json["organisationId"],
        deviceType: json["deviceType"] == null ? undefined : json["deviceType"],
        operationalAt:
            json["operationalAt"] == null
                ? undefined
                : new Date(json["operationalAt"]),
        createdAt:
            json["createdAt"] == null ? undefined : new Date(json["createdAt"]),
        updatedAt:
            json["updatedAt"] == null ? undefined : new Date(json["updatedAt"]),
        onlineStatusUpdatedAt:
            json["onlineStatusUpdatedAt"] == null
                ? undefined
                : new Date(json["onlineStatusUpdatedAt"]),
        statusUpdatedAt:
            json["statusUpdatedAt"] == null
                ? undefined
                : new Date(json["statusUpdatedAt"]),
        decommissionedAt:
            json["decommissionedAt"] == null
                ? undefined
                : new Date(json["decommissionedAt"]),
        reprovisioningExpiresAt:
            json["reprovisioningExpiresAt"] == null
                ? undefined
                : new Date(json["reprovisioningExpiresAt"]),
        deviceRegistrationStatus:
            json["deviceRegistrationStatus"] == null
                ? undefined
                : json["deviceRegistrationStatus"],
        serviceDeviceState:
            json["serviceDeviceState"] == null
                ? undefined
                : json["serviceDeviceState"],
        online: json["online"] == null ? undefined : json["online"],
        serialNumber:
            json["serialNumber"] == null ? undefined : json["serialNumber"],
        vendor: json["vendor"] == null ? undefined : json["vendor"],
        fwVersion: json["fwVersion"] == null ? undefined : json["fwVersion"],
        model: json["model"] == null ? undefined : json["model"],
        status: json["status"] == null ? undefined : json["status"],
        simpleDeviceState:
            json["simpleDeviceState"] == null
                ? undefined
                : json["simpleDeviceState"],
        parentInstallationId:
            json["parentInstallationId"] == null
                ? undefined
                : json["parentInstallationId"],
        payMateDeviceInstallationId:
            json["payMateDeviceInstallationId"] == null
                ? undefined
                : json["payMateDeviceInstallationId"],
        passthroughConfigId:
            json["passthroughConfigId"] == null
                ? undefined
                : json["passthroughConfigId"],
        readonlyPassthroughConfigId:
            json["readonlyPassthroughConfigId"] == null
                ? undefined
                : json["readonlyPassthroughConfigId"],
        latitude: json["latitude"] == null ? undefined : json["latitude"],
        longitude: json["longitude"] == null ? undefined : json["longitude"],
        address: json["address"] == null ? undefined : json["address"],
        deviceOwnerId:
            json["deviceOwnerId"] == null ? undefined : json["deviceOwnerId"],
        friendlyName:
            json["friendlyName"] == null ? undefined : json["friendlyName"],
        timeZone: json["timeZone"] == null ? undefined : json["timeZone"],
        siteName: json["siteName"] == null ? undefined : json["siteName"],
        organisationName:
            json["organisationName"] == null
                ? undefined
                : json["organisationName"],
        internalNotes:
            json["internalNotes"] == null ? undefined : json["internalNotes"],
        deviceUptime:
            json["deviceUptime"] == null
                ? undefined
                : DeviceUptimeResponseFromJSON(json["deviceUptime"]),
        childDevices:
            json["childDevices"] == null
                ? undefined
                : (json["childDevices"] as Array<any>).map(
                      RelatedDeviceDtoFromJSON,
                  ),
        payMateChargerDevices:
            json["payMateChargerDevices"] == null
                ? undefined
                : (json["payMateChargerDevices"] as Array<any>).map(
                      RelatedDeviceDtoFromJSON,
                  ),
        accessTags: json["accessTags"] == null ? undefined : json["accessTags"],
        deviceGroupTags:
            json["deviceGroupTags"] == null
                ? undefined
                : json["deviceGroupTags"],
        configurationItems:
            json["configurationItems"] == null
                ? undefined
                : (json["configurationItems"] as Array<any>).map(
                      DeviceConfigurationItemDtoFromJSON,
                  ),
        configurationExtendedItems:
            json["configurationExtendedItems"] == null
                ? undefined
                : (json["configurationExtendedItems"] as Array<any>).map(
                      DeviceConfigurationExtendedItemDtoFromJSON,
                  ),
        connectors:
            json["connectors"] == null
                ? undefined
                : (json["connectors"] as Array<any>).map(ConnectorDtoFromJSON),
        chargePointMetadata:
            json["chargePointMetadata"] == null
                ? undefined
                : ChargePointMetadataDtoFromJSON(json["chargePointMetadata"]),
        linkMetadata:
            json["linkMetadata"] == null
                ? undefined
                : LinkMetadataDtoFromJSON(json["linkMetadata"]),
        powerMeterMetadata:
            json["powerMeterMetadata"] == null
                ? undefined
                : PowerMeterMetadataDtoFromJSON(json["powerMeterMetadata"]),
        waveMetadata:
            json["waveMetadata"] == null
                ? undefined
                : WaveMetadataDtoFromJSON(json["waveMetadata"]),
        coreMetadata:
            json["coreMetadata"] == null
                ? undefined
                : CoreMetadataDtoFromJSON(json["coreMetadata"]),
        payMateMetadata:
            json["payMateMetadata"] == null
                ? undefined
                : PayMateMetadataDtoFromJSON(json["payMateMetadata"]),
        deviceAddress:
            json["deviceAddress"] == null
                ? undefined
                : AddressDtoFromJSON(json["deviceAddress"]),
        protocol: json["protocol"] == null ? undefined : json["protocol"],
        reportedProtocols:
            json["reportedProtocols"] == null
                ? undefined
                : json["reportedProtocols"],
        isDecommissioned:
            json["isDecommissioned"] == null
                ? undefined
                : json["isDecommissioned"],
        deviceCatalogue:
            json["deviceCatalogue"] == null
                ? undefined
                : DeviceCatalogueDtoFromJSON(json["deviceCatalogue"]),
    };
}

export function DeviceDtoToJSON(value?: DeviceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        installationId: value["installationId"],
        deviceArchiveId: value["deviceArchiveId"],
        deviceIdentity: value["deviceIdentity"],
        organisationId: value["organisationId"],
        deviceType: value["deviceType"],
        operationalAt:
            value["operationalAt"] == null
                ? undefined
                : value["operationalAt"].toISOString(),
        createdAt:
            value["createdAt"] == null
                ? undefined
                : value["createdAt"].toISOString(),
        updatedAt:
            value["updatedAt"] == null
                ? undefined
                : value["updatedAt"].toISOString(),
        onlineStatusUpdatedAt:
            value["onlineStatusUpdatedAt"] == null
                ? undefined
                : value["onlineStatusUpdatedAt"].toISOString(),
        statusUpdatedAt:
            value["statusUpdatedAt"] == null
                ? undefined
                : value["statusUpdatedAt"].toISOString(),
        decommissionedAt:
            value["decommissionedAt"] == null
                ? undefined
                : value["decommissionedAt"].toISOString(),
        reprovisioningExpiresAt:
            value["reprovisioningExpiresAt"] == null
                ? undefined
                : value["reprovisioningExpiresAt"].toISOString(),
        deviceRegistrationStatus: value["deviceRegistrationStatus"],
        serviceDeviceState: value["serviceDeviceState"],
        online: value["online"],
        serialNumber: value["serialNumber"],
        vendor: value["vendor"],
        fwVersion: value["fwVersion"],
        model: value["model"],
        status: value["status"],
        simpleDeviceState: value["simpleDeviceState"],
        parentInstallationId: value["parentInstallationId"],
        payMateDeviceInstallationId: value["payMateDeviceInstallationId"],
        passthroughConfigId: value["passthroughConfigId"],
        readonlyPassthroughConfigId: value["readonlyPassthroughConfigId"],
        latitude: value["latitude"],
        longitude: value["longitude"],
        address: value["address"],
        deviceOwnerId: value["deviceOwnerId"],
        friendlyName: value["friendlyName"],
        timeZone: value["timeZone"],
        siteName: value["siteName"],
        organisationName: value["organisationName"],
        internalNotes: value["internalNotes"],
        deviceUptime: DeviceUptimeResponseToJSON(value["deviceUptime"]),
        childDevices:
            value["childDevices"] == null
                ? undefined
                : (value["childDevices"] as Array<any>).map(
                      RelatedDeviceDtoToJSON,
                  ),
        payMateChargerDevices:
            value["payMateChargerDevices"] == null
                ? undefined
                : (value["payMateChargerDevices"] as Array<any>).map(
                      RelatedDeviceDtoToJSON,
                  ),
        accessTags: value["accessTags"],
        deviceGroupTags: value["deviceGroupTags"],
        configurationItems:
            value["configurationItems"] == null
                ? undefined
                : (value["configurationItems"] as Array<any>).map(
                      DeviceConfigurationItemDtoToJSON,
                  ),
        configurationExtendedItems:
            value["configurationExtendedItems"] == null
                ? undefined
                : (value["configurationExtendedItems"] as Array<any>).map(
                      DeviceConfigurationExtendedItemDtoToJSON,
                  ),
        connectors:
            value["connectors"] == null
                ? undefined
                : (value["connectors"] as Array<any>).map(ConnectorDtoToJSON),
        chargePointMetadata: ChargePointMetadataDtoToJSON(
            value["chargePointMetadata"],
        ),
        linkMetadata: LinkMetadataDtoToJSON(value["linkMetadata"]),
        powerMeterMetadata: PowerMeterMetadataDtoToJSON(
            value["powerMeterMetadata"],
        ),
        waveMetadata: WaveMetadataDtoToJSON(value["waveMetadata"]),
        coreMetadata: CoreMetadataDtoToJSON(value["coreMetadata"]),
        payMateMetadata: PayMateMetadataDtoToJSON(value["payMateMetadata"]),
        deviceAddress: AddressDtoToJSON(value["deviceAddress"]),
        protocol: value["protocol"],
        reportedProtocols: value["reportedProtocols"],
        isDecommissioned: value["isDecommissioned"],
        deviceCatalogue: DeviceCatalogueDtoToJSON(value["deviceCatalogue"]),
    };
}
